import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var authSchema = {
    "2fa_token": new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            placeholder: 'Authentication Code',
            type: 'text'
        }),
        elementType: 'input',
        value: '',
        addon: {
            icon: 'fa fa-lock',
            position: 'left'
        },
        validation: {
            required: true
        },
        valid: true,
        wrapperClass: 'inputSpacer',
        touched: true,
        errorMsg: 'Моля, въведете валиден код',
        maxLength: '50'
    }),
};
export default authSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/authSchema.ts
// module id = 624
// module chunks = 0